export const XS_MIN = 0;
export const SM_MIN = 576;
export const MD_MIN = 768;
export const LG_MIN = 992;
export const XL_MIN = 1200;
export const XXL_MIN = 1400;

export const XS_MAX = SM_MIN - 1;
export const SM_MAX = MD_MIN - 1;
export const MD_MAX = LG_MIN - 1;
export const LG_MAX = XL_MIN - 1;
export const XL_MAX = XXL_MIN - 1;

export const XS_MIN_PX = `${XS_MIN}px`;
export const SM_MIN_PX = `${SM_MIN}px`;
export const MD_MIN_PX = `${MD_MIN}px`;
export const LG_MIN_PX = `${LG_MIN}px`;
export const XL_MIN_PX = `${XL_MIN}px`;

export const XS_MAX_PX = `${XS_MAX}px`;
export const SM_MAX_PX = `${SM_MAX}px`;
export const MD_MAX_PX = `${MD_MAX}px`;
export const LG_MAX_PX = `${LG_MAX}px`;
